/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterCompleteRouteImport } from './routes/register-complete'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as AppRouteImport } from './routes/app'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as RecoveryResetV2RouteImport } from './routes/recovery/reset-v2'
import { Route as RecoveryOtpV2RouteImport } from './routes/recovery/otp-v2'
import { Route as RecoveryForgotRouteImport } from './routes/recovery/forgot'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppServiceHistoryRouteImport } from './routes/app/service-history'
import { Route as AppRequestsRouteImport } from './routes/app/requests'
import { Route as AppEarningsRouteImport } from './routes/app/earnings'
import { Route as AppBranchesRouteImport } from './routes/app/branches'
import { Route as AppAnalyticsRouteImport } from './routes/app/analytics'
import { Route as AppServiceHistoryIndexRouteImport } from './routes/app/service-history/index'
import { Route as AppSettingsUserSettingsRouteImport } from './routes/app/settings/user-settings'
import { Route as AppSettingsUserManagementRouteImport } from './routes/app/settings/user-management'
import { Route as AppSettingsBusinessSettingsRouteImport } from './routes/app/settings/business-settings'
import { Route as AppSettingsBranchSettingsRouteImport } from './routes/app/settings/branch-settings'
import { Route as AppServiceHistoryIdRouteImport } from './routes/app/service-history/$id'
import { Route as AppRequestsIdIndexRouteImport } from './routes/app/requests/$id/index'
import { Route as AppSettingsBranchSettingsServiceCapabilitiesRouteImport } from './routes/app/settings/branch-settings/service-capabilities'
import { Route as AppSettingsBranchSettingsGeneralRouteImport } from './routes/app/settings/branch-settings/general'
import { Route as AppSettingsBranchSettingsBusinessHoursRouteImport } from './routes/app/settings/branch-settings/business-hours'
import { Route as AppSettingsBranchSettingsBranchIdentityRouteImport } from './routes/app/settings/branch-settings/branch-identity'
import { Route as AppRequestsIdMobileRouteImport } from './routes/app/requests/$id/mobile'
import { Route as MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRouteImport } from './routes/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/index'
import { Route as MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRouteImport } from './routes/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/index'
import { Route as MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRouteImport } from './routes/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission'
import { Route as MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRouteImport } from './routes/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival'
import { Route as MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRouteImport } from './routes/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission'

const RegisterCompleteRoute = RegisterCompleteRouteImport.update({
  id: '/register-complete',
  path: '/register-complete',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const RecoveryResetV2Route = RecoveryResetV2RouteImport.update({
  id: '/recovery/reset-v2',
  path: '/recovery/reset-v2',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoveryOtpV2Route = RecoveryOtpV2RouteImport.update({
  id: '/recovery/otp-v2',
  path: '/recovery/otp-v2',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoveryForgotRoute = RecoveryForgotRouteImport.update({
  id: '/recovery/forgot',
  path: '/recovery/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppServiceHistoryRoute = AppServiceHistoryRouteImport.update({
  id: '/service-history',
  path: '/service-history',
  getParentRoute: () => AppRoute,
} as any)
const AppRequestsRoute = AppRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppRoute,
} as any)
const AppEarningsRoute = AppEarningsRouteImport.update({
  id: '/earnings',
  path: '/earnings',
  getParentRoute: () => AppRoute,
} as any)
const AppBranchesRoute = AppBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppServiceHistoryIndexRoute = AppServiceHistoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppServiceHistoryRoute,
} as any)
const AppSettingsUserSettingsRoute = AppSettingsUserSettingsRouteImport.update({
  id: '/user-settings',
  path: '/user-settings',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUserManagementRoute =
  AppSettingsUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsBusinessSettingsRoute =
  AppSettingsBusinessSettingsRouteImport.update({
    id: '/business-settings',
    path: '/business-settings',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsBranchSettingsRoute =
  AppSettingsBranchSettingsRouteImport.update({
    id: '/branch-settings',
    path: '/branch-settings',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppServiceHistoryIdRoute = AppServiceHistoryIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppServiceHistoryRoute,
} as any)
const AppRequestsIdIndexRoute = AppRequestsIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AppRequestsRoute,
} as any)
const AppSettingsBranchSettingsServiceCapabilitiesRoute =
  AppSettingsBranchSettingsServiceCapabilitiesRouteImport.update({
    id: '/service-capabilities',
    path: '/service-capabilities',
    getParentRoute: () => AppSettingsBranchSettingsRoute,
  } as any)
const AppSettingsBranchSettingsGeneralRoute =
  AppSettingsBranchSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AppSettingsBranchSettingsRoute,
  } as any)
const AppSettingsBranchSettingsBusinessHoursRoute =
  AppSettingsBranchSettingsBusinessHoursRouteImport.update({
    id: '/business-hours',
    path: '/business-hours',
    getParentRoute: () => AppSettingsBranchSettingsRoute,
  } as any)
const AppSettingsBranchSettingsBranchIdentityRoute =
  AppSettingsBranchSettingsBranchIdentityRouteImport.update({
    id: '/branch-identity',
    path: '/branch-identity',
    getParentRoute: () => AppSettingsBranchSettingsRoute,
  } as any)
const AppRequestsIdMobileRoute = AppRequestsIdMobileRouteImport.update({
  id: '/$id/mobile',
  path: '/$id/mobile',
  getParentRoute: () => AppRequestsRoute,
} as any)
const MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute =
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRouteImport.update(
    {
      id: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/',
      path: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute =
  MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRouteImport.update(
    {
      id: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/',
      path: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRoute =
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRouteImport.update(
    {
      id: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission',
      path: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRoute =
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRouteImport.update(
    {
      id: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival',
      path: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRoute =
  MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRouteImport.update(
    {
      id: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission',
      path: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission',
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/app': typeof AppRouteWithChildren
  '/categories': typeof CategoriesRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/register-complete': typeof RegisterCompleteRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/branches': typeof AppBranchesRoute
  '/app/earnings': typeof AppEarningsRoute
  '/app/requests': typeof AppRequestsRouteWithChildren
  '/app/service-history': typeof AppServiceHistoryRouteWithChildren
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/recovery/forgot': typeof RecoveryForgotRoute
  '/recovery/otp-v2': typeof RecoveryOtpV2Route
  '/recovery/reset-v2': typeof RecoveryResetV2Route
  '/app/': typeof AppIndexRoute
  '/app/service-history/$id': typeof AppServiceHistoryIdRoute
  '/app/settings/branch-settings': typeof AppSettingsBranchSettingsRouteWithChildren
  '/app/settings/business-settings': typeof AppSettingsBusinessSettingsRoute
  '/app/settings/user-management': typeof AppSettingsUserManagementRoute
  '/app/settings/user-settings': typeof AppSettingsUserSettingsRoute
  '/app/service-history/': typeof AppServiceHistoryIndexRoute
  '/app/requests/$id/mobile': typeof AppRequestsIdMobileRoute
  '/app/settings/branch-settings/branch-identity': typeof AppSettingsBranchSettingsBranchIdentityRoute
  '/app/settings/branch-settings/business-hours': typeof AppSettingsBranchSettingsBusinessHoursRoute
  '/app/settings/branch-settings/general': typeof AppSettingsBranchSettingsGeneralRoute
  '/app/settings/branch-settings/service-capabilities': typeof AppSettingsBranchSettingsServiceCapabilitiesRoute
  '/app/requests/$id': typeof AppRequestsIdIndexRoute
  '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission': typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRoute
  '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId': typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/categories': typeof CategoriesRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/register-complete': typeof RegisterCompleteRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/branches': typeof AppBranchesRoute
  '/app/earnings': typeof AppEarningsRoute
  '/app/requests': typeof AppRequestsRouteWithChildren
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/recovery/forgot': typeof RecoveryForgotRoute
  '/recovery/otp-v2': typeof RecoveryOtpV2Route
  '/recovery/reset-v2': typeof RecoveryResetV2Route
  '/app': typeof AppIndexRoute
  '/app/service-history/$id': typeof AppServiceHistoryIdRoute
  '/app/settings/branch-settings': typeof AppSettingsBranchSettingsRouteWithChildren
  '/app/settings/business-settings': typeof AppSettingsBusinessSettingsRoute
  '/app/settings/user-management': typeof AppSettingsUserManagementRoute
  '/app/settings/user-settings': typeof AppSettingsUserSettingsRoute
  '/app/service-history': typeof AppServiceHistoryIndexRoute
  '/app/requests/$id/mobile': typeof AppRequestsIdMobileRoute
  '/app/settings/branch-settings/branch-identity': typeof AppSettingsBranchSettingsBranchIdentityRoute
  '/app/settings/branch-settings/business-hours': typeof AppSettingsBranchSettingsBusinessHoursRoute
  '/app/settings/branch-settings/general': typeof AppSettingsBranchSettingsGeneralRoute
  '/app/settings/branch-settings/service-capabilities': typeof AppSettingsBranchSettingsServiceCapabilitiesRoute
  '/app/requests/$id': typeof AppRequestsIdIndexRoute
  '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission': typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRoute
  '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId': typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/app': typeof AppRouteWithChildren
  '/categories': typeof CategoriesRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/register-complete': typeof RegisterCompleteRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/branches': typeof AppBranchesRoute
  '/app/earnings': typeof AppEarningsRoute
  '/app/requests': typeof AppRequestsRouteWithChildren
  '/app/service-history': typeof AppServiceHistoryRouteWithChildren
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/recovery/forgot': typeof RecoveryForgotRoute
  '/recovery/otp-v2': typeof RecoveryOtpV2Route
  '/recovery/reset-v2': typeof RecoveryResetV2Route
  '/app/': typeof AppIndexRoute
  '/app/service-history/$id': typeof AppServiceHistoryIdRoute
  '/app/settings/branch-settings': typeof AppSettingsBranchSettingsRouteWithChildren
  '/app/settings/business-settings': typeof AppSettingsBusinessSettingsRoute
  '/app/settings/user-management': typeof AppSettingsUserManagementRoute
  '/app/settings/user-settings': typeof AppSettingsUserSettingsRoute
  '/app/service-history/': typeof AppServiceHistoryIndexRoute
  '/app/requests/$id/mobile': typeof AppRequestsIdMobileRoute
  '/app/settings/branch-settings/branch-identity': typeof AppSettingsBranchSettingsBranchIdentityRoute
  '/app/settings/branch-settings/business-hours': typeof AppSettingsBranchSettingsBusinessHoursRoute
  '/app/settings/branch-settings/general': typeof AppSettingsBranchSettingsGeneralRoute
  '/app/settings/branch-settings/service-capabilities': typeof AppSettingsBranchSettingsServiceCapabilitiesRoute
  '/app/requests/$id/': typeof AppRequestsIdIndexRoute
  '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission': typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRoute
  '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/': typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute
  '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/': typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/app'
    | '/categories'
    | '/login'
    | '/register'
    | '/register-complete'
    | '/app/analytics'
    | '/app/branches'
    | '/app/earnings'
    | '/app/requests'
    | '/app/service-history'
    | '/app/settings'
    | '/recovery/forgot'
    | '/recovery/otp-v2'
    | '/recovery/reset-v2'
    | '/app/'
    | '/app/service-history/$id'
    | '/app/settings/branch-settings'
    | '/app/settings/business-settings'
    | '/app/settings/user-management'
    | '/app/settings/user-settings'
    | '/app/service-history/'
    | '/app/requests/$id/mobile'
    | '/app/settings/branch-settings/branch-identity'
    | '/app/settings/branch-settings/business-hours'
    | '/app/settings/branch-settings/general'
    | '/app/settings/branch-settings/service-capabilities'
    | '/app/requests/$id'
    | '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission'
    | '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/categories'
    | '/login'
    | '/register'
    | '/register-complete'
    | '/app/analytics'
    | '/app/branches'
    | '/app/earnings'
    | '/app/requests'
    | '/app/settings'
    | '/recovery/forgot'
    | '/recovery/otp-v2'
    | '/recovery/reset-v2'
    | '/app'
    | '/app/service-history/$id'
    | '/app/settings/branch-settings'
    | '/app/settings/business-settings'
    | '/app/settings/user-management'
    | '/app/settings/user-settings'
    | '/app/service-history'
    | '/app/requests/$id/mobile'
    | '/app/settings/branch-settings/branch-identity'
    | '/app/settings/branch-settings/business-hours'
    | '/app/settings/branch-settings/general'
    | '/app/settings/branch-settings/service-capabilities'
    | '/app/requests/$id'
    | '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission'
    | '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/app'
    | '/categories'
    | '/login'
    | '/register'
    | '/register-complete'
    | '/app/analytics'
    | '/app/branches'
    | '/app/earnings'
    | '/app/requests'
    | '/app/service-history'
    | '/app/settings'
    | '/recovery/forgot'
    | '/recovery/otp-v2'
    | '/recovery/reset-v2'
    | '/app/'
    | '/app/service-history/$id'
    | '/app/settings/branch-settings'
    | '/app/settings/business-settings'
    | '/app/settings/user-management'
    | '/app/settings/user-settings'
    | '/app/service-history/'
    | '/app/requests/$id/mobile'
    | '/app/settings/branch-settings/branch-identity'
    | '/app/settings/branch-settings/business-hours'
    | '/app/settings/branch-settings/general'
    | '/app/settings/branch-settings/service-capabilities'
    | '/app/requests/$id/'
    | '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission'
    | '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/'
    | '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AppRoute: typeof AppRouteWithChildren
  CategoriesRoute: typeof CategoriesRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  RegisterCompleteRoute: typeof RegisterCompleteRoute
  RecoveryForgotRoute: typeof RecoveryForgotRoute
  RecoveryOtpV2Route: typeof RecoveryOtpV2Route
  RecoveryResetV2Route: typeof RecoveryResetV2Route
  MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRoute: typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRoute
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRoute: typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRoute
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRoute: typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRoute
  MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute: typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute: typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register-complete': {
      id: '/register-complete'
      path: '/register-complete'
      fullPath: '/register-complete'
      preLoaderRoute: typeof RegisterCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/recovery/reset-v2': {
      id: '/recovery/reset-v2'
      path: '/recovery/reset-v2'
      fullPath: '/recovery/reset-v2'
      preLoaderRoute: typeof RecoveryResetV2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recovery/otp-v2': {
      id: '/recovery/otp-v2'
      path: '/recovery/otp-v2'
      fullPath: '/recovery/otp-v2'
      preLoaderRoute: typeof RecoveryOtpV2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recovery/forgot': {
      id: '/recovery/forgot'
      path: '/recovery/forgot'
      fullPath: '/recovery/forgot'
      preLoaderRoute: typeof RecoveryForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/service-history': {
      id: '/app/service-history'
      path: '/service-history'
      fullPath: '/app/service-history'
      preLoaderRoute: typeof AppServiceHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/requests': {
      id: '/app/requests'
      path: '/requests'
      fullPath: '/app/requests'
      preLoaderRoute: typeof AppRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/earnings': {
      id: '/app/earnings'
      path: '/earnings'
      fullPath: '/app/earnings'
      preLoaderRoute: typeof AppEarningsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/branches': {
      id: '/app/branches'
      path: '/branches'
      fullPath: '/app/branches'
      preLoaderRoute: typeof AppBranchesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/analytics': {
      id: '/app/analytics'
      path: '/analytics'
      fullPath: '/app/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/service-history/': {
      id: '/app/service-history/'
      path: '/'
      fullPath: '/app/service-history/'
      preLoaderRoute: typeof AppServiceHistoryIndexRouteImport
      parentRoute: typeof AppServiceHistoryRoute
    }
    '/app/settings/user-settings': {
      id: '/app/settings/user-settings'
      path: '/user-settings'
      fullPath: '/app/settings/user-settings'
      preLoaderRoute: typeof AppSettingsUserSettingsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/user-management': {
      id: '/app/settings/user-management'
      path: '/user-management'
      fullPath: '/app/settings/user-management'
      preLoaderRoute: typeof AppSettingsUserManagementRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/business-settings': {
      id: '/app/settings/business-settings'
      path: '/business-settings'
      fullPath: '/app/settings/business-settings'
      preLoaderRoute: typeof AppSettingsBusinessSettingsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/branch-settings': {
      id: '/app/settings/branch-settings'
      path: '/branch-settings'
      fullPath: '/app/settings/branch-settings'
      preLoaderRoute: typeof AppSettingsBranchSettingsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/service-history/$id': {
      id: '/app/service-history/$id'
      path: '/$id'
      fullPath: '/app/service-history/$id'
      preLoaderRoute: typeof AppServiceHistoryIdRouteImport
      parentRoute: typeof AppServiceHistoryRoute
    }
    '/app/requests/$id/': {
      id: '/app/requests/$id/'
      path: '/$id'
      fullPath: '/app/requests/$id'
      preLoaderRoute: typeof AppRequestsIdIndexRouteImport
      parentRoute: typeof AppRequestsRoute
    }
    '/app/settings/branch-settings/service-capabilities': {
      id: '/app/settings/branch-settings/service-capabilities'
      path: '/service-capabilities'
      fullPath: '/app/settings/branch-settings/service-capabilities'
      preLoaderRoute: typeof AppSettingsBranchSettingsServiceCapabilitiesRouteImport
      parentRoute: typeof AppSettingsBranchSettingsRoute
    }
    '/app/settings/branch-settings/general': {
      id: '/app/settings/branch-settings/general'
      path: '/general'
      fullPath: '/app/settings/branch-settings/general'
      preLoaderRoute: typeof AppSettingsBranchSettingsGeneralRouteImport
      parentRoute: typeof AppSettingsBranchSettingsRoute
    }
    '/app/settings/branch-settings/business-hours': {
      id: '/app/settings/branch-settings/business-hours'
      path: '/business-hours'
      fullPath: '/app/settings/branch-settings/business-hours'
      preLoaderRoute: typeof AppSettingsBranchSettingsBusinessHoursRouteImport
      parentRoute: typeof AppSettingsBranchSettingsRoute
    }
    '/app/settings/branch-settings/branch-identity': {
      id: '/app/settings/branch-settings/branch-identity'
      path: '/branch-identity'
      fullPath: '/app/settings/branch-settings/branch-identity'
      preLoaderRoute: typeof AppSettingsBranchSettingsBranchIdentityRouteImport
      parentRoute: typeof AppSettingsBranchSettingsRoute
    }
    '/app/requests/$id/mobile': {
      id: '/app/requests/$id/mobile'
      path: '/$id/mobile'
      fullPath: '/app/requests/$id/mobile'
      preLoaderRoute: typeof AppRequestsIdMobileRouteImport
      parentRoute: typeof AppRequestsRoute
    }
    '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/': {
      id: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/'
      path: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId'
      fullPath: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId'
      preLoaderRoute: typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/': {
      id: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/'
      path: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId'
      fullPath: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId'
      preLoaderRoute: typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission': {
      id: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission'
      path: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission'
      fullPath: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/inspection-submission'
      preLoaderRoute: typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival': {
      id: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival'
      path: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival'
      fullPath: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/arrival'
      preLoaderRoute: typeof MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission': {
      id: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission'
      path: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission'
      fullPath: '/mobile-inspection/provider-branch/$providerBranchId/request/$requestId/mobile-submission'
      preLoaderRoute: typeof MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppRequestsRouteChildren {
  AppRequestsIdMobileRoute: typeof AppRequestsIdMobileRoute
  AppRequestsIdIndexRoute: typeof AppRequestsIdIndexRoute
}

const AppRequestsRouteChildren: AppRequestsRouteChildren = {
  AppRequestsIdMobileRoute: AppRequestsIdMobileRoute,
  AppRequestsIdIndexRoute: AppRequestsIdIndexRoute,
}

const AppRequestsRouteWithChildren = AppRequestsRoute._addFileChildren(
  AppRequestsRouteChildren,
)

interface AppServiceHistoryRouteChildren {
  AppServiceHistoryIdRoute: typeof AppServiceHistoryIdRoute
  AppServiceHistoryIndexRoute: typeof AppServiceHistoryIndexRoute
}

const AppServiceHistoryRouteChildren: AppServiceHistoryRouteChildren = {
  AppServiceHistoryIdRoute: AppServiceHistoryIdRoute,
  AppServiceHistoryIndexRoute: AppServiceHistoryIndexRoute,
}

const AppServiceHistoryRouteWithChildren =
  AppServiceHistoryRoute._addFileChildren(AppServiceHistoryRouteChildren)

interface AppSettingsBranchSettingsRouteChildren {
  AppSettingsBranchSettingsBranchIdentityRoute: typeof AppSettingsBranchSettingsBranchIdentityRoute
  AppSettingsBranchSettingsBusinessHoursRoute: typeof AppSettingsBranchSettingsBusinessHoursRoute
  AppSettingsBranchSettingsGeneralRoute: typeof AppSettingsBranchSettingsGeneralRoute
  AppSettingsBranchSettingsServiceCapabilitiesRoute: typeof AppSettingsBranchSettingsServiceCapabilitiesRoute
}

const AppSettingsBranchSettingsRouteChildren: AppSettingsBranchSettingsRouteChildren =
  {
    AppSettingsBranchSettingsBranchIdentityRoute:
      AppSettingsBranchSettingsBranchIdentityRoute,
    AppSettingsBranchSettingsBusinessHoursRoute:
      AppSettingsBranchSettingsBusinessHoursRoute,
    AppSettingsBranchSettingsGeneralRoute:
      AppSettingsBranchSettingsGeneralRoute,
    AppSettingsBranchSettingsServiceCapabilitiesRoute:
      AppSettingsBranchSettingsServiceCapabilitiesRoute,
  }

const AppSettingsBranchSettingsRouteWithChildren =
  AppSettingsBranchSettingsRoute._addFileChildren(
    AppSettingsBranchSettingsRouteChildren,
  )

interface AppSettingsRouteChildren {
  AppSettingsBranchSettingsRoute: typeof AppSettingsBranchSettingsRouteWithChildren
  AppSettingsBusinessSettingsRoute: typeof AppSettingsBusinessSettingsRoute
  AppSettingsUserManagementRoute: typeof AppSettingsUserManagementRoute
  AppSettingsUserSettingsRoute: typeof AppSettingsUserSettingsRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBranchSettingsRoute: AppSettingsBranchSettingsRouteWithChildren,
  AppSettingsBusinessSettingsRoute: AppSettingsBusinessSettingsRoute,
  AppSettingsUserManagementRoute: AppSettingsUserManagementRoute,
  AppSettingsUserSettingsRoute: AppSettingsUserSettingsRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppBranchesRoute: typeof AppBranchesRoute
  AppEarningsRoute: typeof AppEarningsRoute
  AppRequestsRoute: typeof AppRequestsRouteWithChildren
  AppServiceHistoryRoute: typeof AppServiceHistoryRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppBranchesRoute: AppBranchesRoute,
  AppEarningsRoute: AppEarningsRoute,
  AppRequestsRoute: AppRequestsRouteWithChildren,
  AppServiceHistoryRoute: AppServiceHistoryRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AppRoute: AppRouteWithChildren,
  CategoriesRoute: CategoriesRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  RegisterCompleteRoute: RegisterCompleteRoute,
  RecoveryForgotRoute: RecoveryForgotRoute,
  RecoveryOtpV2Route: RecoveryOtpV2Route,
  RecoveryResetV2Route: RecoveryResetV2Route,
  MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRoute:
    MobileInspectionProviderBranchProviderBranchIdRequestRequestIdMobileSubmissionRoute,
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRoute:
    MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdArrivalRoute,
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRoute:
    MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdInspectionSubmissionRoute,
  MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute:
    MobileInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute,
  MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute:
    MobileMultiInspectionProviderBranchProviderBranchIdRequestRequestIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
